import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {MaterialNode} from "#template/nodes/material/material-node"
import type {MaterialGraph} from "@cm/material-nodes"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {NodeEvaluator} from "#template/node-evaluator"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import {LoadMaterialRevision} from "#template/runtime-graph/nodes/load-material-revision"

export type MaterialReferenceParameters = {
    name: string
    materialId: number
    materialRevisionId: number | null
}

const materialReferenceDefinition: TemplateNodeDefinition<MaterialReferenceParameters> = {
    nodeClass: "MaterialReference",
    validation: {
        parameters: z.object({
            name: z.string(),
            materialId: z.number(),
            materialRevisionId: z.nullable(z.number()),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MaterialReference extends MaterialNode<MaterialReferenceParameters> {
    public override get definition() {
        return materialReferenceDefinition
    }

    override evaluate(scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<MaterialGraph | null> {
        const {materialGraph} = scope.node(LoadMaterialRevision, {
            sceneManager: evaluator.templateContext.sceneManager,
            materialId: this.parameters.materialId,
            materialRevisionId: this.parameters.materialRevisionId,
            flatten: true,
        })
        return materialGraph
    }
}
